var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"foto-met-tekst-gallery-card",class:_vm.rootClassName},[_c('img',{staticClass:"foto-met-tekst-image",attrs:{"alt":_vm.imageAlt,"src":_vm.imageSrc}}),_c('h2',{staticClass:"foto-met-tekst-text"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }